<div class="row justify-content-center" *ngIf="showFilters && !searchTriggered">
    <div class="col-8">
        <div class="row align-items-center mb-3">
            <div class="col-auto px-0">
            </div>
            <div class="col-12 pl-0">
                <span class="search-icon position-absolute">
                    <em class="material-icons-outlined font-5x mt-1" aria-hidden="true">search</em>
                </span>
                <label class="sr-only" for="searchTaxonomies">Search</label>
                <input class="form-control search-inputfield ng-pristine ng-valid ng-touched" id="searchTaxonomies" type="search" placeholder="Search taxonomies"
                    [(ngModel)]="searchKeyword">
                <button aria-label="Clear search" class="cursor-pointer search-clear position-absolute" type="button" (click)="searchKeyword = ''">×</button>
            </div>
        </div>

        <ng-container *ngIf="dropdownServiceLoaded">
            <ng-container *ngIf="showFilters && !searchTriggered">

                <ng-container *ngIf="dropdownDisplayObj && Object.keys(dropdownDisplayObj)">
                    <div class="form-group row mb-0" [ngStyle]="{'visibility':filterVisibility ? '' : 'hidden' }">
                        <ng-container *ngFor="let key of Object.keys(dropdownDisplayObj); let i = index;">
                            <div class="position-relative w-100 mb-3 pr-3 association-multiselect" *ngIf="(dropdownDisplayObj[key].length > 0) && selectedFilters[key]">

                                <app-multi-select-dropdown [label]="key" [viewLocation]="'acmt-search'" [data]="dropdownDisplayObj[key]" id="{{'-multiselect-'+key}}"
                                    [dropdownSettings]="dropdownSettings" (SelectEvent)="captureSelectedFilters($event)">
                                </app-multi-select-dropdown>

                                <button class="btn btn-clear cursor-pointer delete-multiselect position-absolute" aria-label="Close dropdown" *ngIf="key !== 'taxonomies' &&  key !== 'node type'" (click)="removeFilter(key);">
                                    <em class="material-icons-outlined font-4x" aria-hidden="true">delete</em>
                                </button>
                            </div>
                        </ng-container>
                    </div>
                </ng-container>
                <div class="form-group row" *ngIf="moreFilterClicked">
                    <div class="position-relative pl-0 pr-3 col-sm-9 offset-sm-3 col-xl-10 offset-xl-2 association-multiselect">
                        <app-multi-select-dropdown [label]="'key'" [viewLocation]="'acmt-search'" [customCol]="true" [data]="moreFilterOptions" id="{{'-multiselect-keys'}}"
                            [dropdownSettings]="moreFilterDropdownSettings" (SelectEvent)="captureKeys($event);">
                        </app-multi-select-dropdown>
                        <button class="btn btn-clear cursor-pointer delete-multiselect position-absolute" aria-label="Close dropdown" (click)="removeMoreFilter();">
                            <em class="material-icons-outlined font-4x" aria-hidden="true">delete</em>
                        </button>
                    </div>
                </div>


                <div class="form-group row">
                    <div class="col-sm-9 offset-sm-3 col-xl-10 offset-xl-2 pl-1" *ngIf="Object.keys(dropdownDisplayObj).length !== Object.keys(selectedFilters).length">
                        <button class="btn btn-clear text-primary p-1 font-bold d-flex align-items-center" type="button" (click)="moreFilters();">
                            <em class="material-icons-outlined font-4x mr-1">add</em>
                            More Filters
                        </button>
                    </div>
                </div>

                <div class="text-center mt-3">
                    <button class="btn btn-clear text-underline mr-2" type="button" (click)="resetSearch(true);">Reset</button>
                    <button class="btn btn-primary btn-sm" type="button" (click)="search();" [disabled]="searchFilters.length ===0 && searchKeyword.length < 3">Search</button>
                </div>
            </ng-container>
        </ng-container>

    </div>
</div>
<!-- Search list start -->
<div class="row justify-content-center">
    <div class="col-12">
        <app-tree-detail-search-list 
            *ngIf="searchTriggered && dataLoaded"
            [searchResult]="searchResult"
            (updatedAssociationsObj)="emitAssociationsObj($event);"
            (removeOptions)="removeCopiedOptions($event);"
            (resetSearchEvent)="resetSearch($event);"
            (setCurrentStep)="setCurrentStep($event)"
            [optionsToCopySaved]="optionsToCopySaved"
            [isCopy]="isCopy"
            [isCopyAssociation]="isCopyAssociation"
            [displayText]="displayText">
        </app-tree-detail-search-list>
    </div>
</div>
<!-- Search list end -->
<div class="col-12 uploader-loading" *ngIf="!dropdownServiceLoaded">
    <app-preloader [loaderText]="'Loading..'" class="w-100 position-absolute preloader-backdrop"></app-preloader>
</div>
<div class="col-12 uploader-loading" *ngIf="searchTriggered && !dataLoaded">
    <app-preloader [loaderText]="'Searching new..'" class="w-100 position-absolute preloader-backdrop"></app-preloader>
</div>